import { renderTemplate } from '../stringUtils';
import { BROADBAND_ICON_TITLE } from './constant';
import './networkInfo.css';

let userConnectionData = sessionStorage.getItem('doselect_connection_status');
userConnectionData = userConnectionData
  ? JSON.parse(userConnectionData)
  : { good: 0, bad: 0, total: 0, offline: 0 };
let offlineInfoRetryCount = 0;
let networkSpeedInterval;
let offlineTrackerInterval;
let currentNetworkInterval;

const initiateNetworkInfoData = ({
  bandwidthLimitCallback,
  bandwidthUpperLimit,
  ubaCallback,
  TEST_IMG,
  downloadSize,
  bandwidthThresholdLimit,
  internetMeasureInterval = 60000,
  offlineInfoInterval = 300000,
  networkIntervalOnFocus = 1000,
  parentComponentId = 'broadbandIcon',
  childSpanClassName = 'broadband-span',
  isAlternativeBroadbandIconEnabled,
  productTypeSmall,
}) => {
  if (isAlternativeBroadbandIconEnabled) {
    import(/* webpackChunkName: "altCss" */ './networkIconAlternative.css');
  }
  // function to calculate the internet speed
  function networkSpeedCalculationInMbps(startTime, endTime) {
    const duration = (endTime - startTime) / 1000;
    const bitsLoaded = downloadSize * 8;
    const speedbps = (bitsLoaded / duration).toFixed(4);
    const speedKbps = (speedbps / 1024).toFixed(4);
    const speedMbps = (speedKbps / 1024).toFixed(4);
    // current download speed is getting stored in session storage
    let imageNetworkSpeed = sessionStorage.getItem('image-internet-speed');
    imageNetworkSpeed = imageNetworkSpeed ? JSON.parse(imageNetworkSpeed) : {};
    imageNetworkSpeed.downloadSpeed = `${speedMbps}`;
    sessionStorage.setItem(
      'image-internet-speed',
      JSON.stringify(imageNetworkSpeed)
    );
    // commulative data is getting calculated and set on session storage
    userConnectionData.total =
      userConnectionData.total > 0 ? userConnectionData.total + 1 : 1;
    if (speedMbps < bandwidthUpperLimit && bandwidthLimitCallback) {
      const broadbandParentIconDiv = document.getElementById(parentComponentId);
      // if threshold upper limit is occurred, callback will be trigerred
      if (speedMbps < bandwidthThresholdLimit && broadbandParentIconDiv) {
        bandwidthLimitCallback();
      }
      userConnectionData.bad =
        userConnectionData.bad > 0 ? userConnectionData.bad + 1 : 1;
    } else {
      userConnectionData.good =
        userConnectionData.good > 0 ? userConnectionData.good + 1 : 1;
    }
    sessionStorage.setItem(
      'doselect_connection_status',
      JSON.stringify(userConnectionData)
    );
    return speedMbps;
  }

  const preDownloadingBroadbandIcon = (
    parent,
    identifierClassname,
    iconClassname
  ) => {
    let preDownloadInternetIcon = parent.querySelector(
      `.${identifierClassname}`
    );
    if (!preDownloadInternetIcon) {
      preDownloadInternetIcon = document.createElement('i');
      preDownloadInternetIcon.classList.add(identifierClassname, iconClassname);
      preDownloadInternetIcon.style.visibility = 'hidden';
    }
    parent.appendChild(preDownloadInternetIcon);
  };

  // UI changes on asked component id and span
  const networkBroadbandIconUI = (parent, classname, speedInMbps) => {
    let networkBroadbandIconSpan = parent.querySelector(
      `.${childSpanClassName}`
    );
    if (networkBroadbandIconSpan) {
      networkBroadbandIconSpan.classList.remove(
        'good-broadband',
        'bad-broadband',
        'no-broadband'
      );
    } else {
      networkBroadbandIconSpan = document.createElement('span');
      networkBroadbandIconSpan.classList.add(childSpanClassName);
    }
    if (!networkBroadbandIconSpan.classList.contains('tooltip-add')) {
      networkBroadbandIconSpan.classList.add('tooltip-add');
    }

    networkBroadbandIconSpan.setAttribute(
      'tip',
      renderTemplate(
        BROADBAND_ICON_TITLE[classname]?.(
          speedInMbps,
          (currentNetworkInterval / 1000).toFixed()
        ),
        { productTypeSmall }
      )
    );
    // since image can not be downloaded offline, pre-downloading it
    preDownloadingBroadbandIcon(parent, 'no-broadband-icon', 'no-broadband');

    // since image can be on pending in slow internet, pre-downloading it
    preDownloadingBroadbandIcon(parent, 'bad-broadband-icon', 'bad-broadband');

    networkBroadbandIconSpan.classList.add(classname);
    parent.appendChild(networkBroadbandIconSpan);
  };
  function measureConnectionSpeed() {
    const broadbandParentIconDiv = document.getElementById(parentComponentId);
    if (window.navigator.onLine) {
      let startTime;
      let endTime;
      const download = new Image();
      download.onload = function() {
        endTime = new Date().getTime();
        const speedInMbps = networkSpeedCalculationInMbps(startTime, endTime);
        if (broadbandParentIconDiv) {
          broadbandParentIconDiv.addEventListener('mouseover', () => {
            clearInterval(networkSpeedInterval);
            networkSpeedInterval = window.setInterval(
              measureConnectionSpeed,
              networkIntervalOnFocus
            );
            currentNetworkInterval = networkIntervalOnFocus;
          });
          broadbandParentIconDiv.addEventListener('mouseout', () => {
            clearInterval(networkSpeedInterval);
            networkSpeedInterval = window.setInterval(
              measureConnectionSpeed,
              internetMeasureInterval
            );
            currentNetworkInterval = internetMeasureInterval;
          });
          networkBroadbandIconUI(
            broadbandParentIconDiv,
            speedInMbps > bandwidthThresholdLimit
              ? 'good-broadband'
              : 'bad-broadband',
            speedInMbps
          );
        }
      };
      // commented the below code if error need to be handle we can utilize it
      // download.onerror = error => {
      //   console.log(error);
      // };

      startTime = new Date().getTime();
      download.src = `${TEST_IMG}?timestamp=${startTime}`;
    } else {
      if (broadbandParentIconDiv) {
        networkBroadbandIconUI(broadbandParentIconDiv, 'no-broadband');
      }
      userConnectionData.total =
        userConnectionData.total > 0 ? userConnectionData.total + 1 : 1;
      userConnectionData.offline =
        userConnectionData.offline > 0 ? userConnectionData.offline + 1 : 1;
      sessionStorage.setItem(
        'doselect_connection_status',
        JSON.stringify(userConnectionData)
      );
    }
  }

  // removing the offline logic from it as per project but will required
  // as plugin thats why not commented it instead of removing

  // function updateOfllineDurationInfo(offlineDuration = 0) {
  //   let offlineDurationInfo = sessionStorage.getItem(
  //     'offline-duration-in-seconds'
  //   );
  //   offlineDurationInfo =
  //     offlineDurationInfo > 0
  //       ? +offlineDurationInfo + +offlineDuration
  //       : +offlineDuration;
  //   sessionStorage.setItem('offline-duration-in-seconds', offlineDurationInfo);
  // }

  function offlineDataInfo() {
    if (window.navigator.onLine) {
      const offlineDurationInfo = localStorage.getItem(
        'offline-duration-in-seconds'
      );
      if (ubaCallback && offlineDurationInfo > 0)
        ubaCallback({
          verbose: 'info:offline-data',
          label: `duration: ${offlineDurationInfo} seconds`,
        });
      offlineInfoRetryCount = 0;

      // Changes for initial debugging, in batching it will be removed
      const signedUrlCounter = localStorage.getItem(
        'signed-url-restapi-counter'
      );
      if (ubaCallback && signedUrlCounter > 0)
        ubaCallback({
          verbose: 'info:signed-url-data',
          label: `Signed-url-counter: ${signedUrlCounter}`,
        });

      // Changes for initial debugging, in batching it will be removed
      const initiatedImageUploadCounter = localStorage.getItem(
        'initiated-image-upload-counter'
      );
      if (ubaCallback && initiatedImageUploadCounter > 0)
        ubaCallback({
          verbose: 'info:initiated-image-upload',
          label: `initiated-image-upload-counter: ${initiatedImageUploadCounter}`,
        });
    } else if (offlineInfoRetryCount < 2) {
      // retry
      offlineInfoRetryCount += 1;
      offlineDataInfo();
    }
  }
  function initiateSpeedDetection() {
    measureConnectionSpeed();
    networkSpeedInterval = window.setInterval(
      measureConnectionSpeed,
      internetMeasureInterval
    );
    currentNetworkInterval = internetMeasureInterval;
    offlineTrackerInterval = window.setInterval(
      offlineDataInfo,
      offlineInfoInterval
    );
  }

  const handleOnline = () => {
    const networkBroadbandiconDiv = document.getElementById(parentComponentId);
    if (networkBroadbandiconDiv) {
      networkBroadbandIconUI(networkBroadbandiconDiv, 'bad-broadband');
    }
    // removing the offline logic from it as per project but will required
    // as plugin thats why not commented it instead of removing

    // let offlineData = sessionStorage.getItem('doselect_offline_status');
    // offlineData = offlineData ? JSON.parse(offlineData) : {};
    // const offlineDataLength = Object.keys(offlineData).length;
    // if (
    //   offlineData &&
    //   offlineDataLength > 0 &&
    //   !offlineData[offlineDataLength].endTime
    // ) {
    //   const lastOfflineData = {
    //     ...offlineData[offlineDataLength],
    //     endTime: new Date(),
    //   };
    //   if (
    //     lastOfflineData &&
    //     lastOfflineData?.endTime &&
    //     lastOfflineData?.startTime
    //   ) {
    //     const duration = (
    //       (new Date(lastOfflineData.endTime) -
    //         new Date(lastOfflineData.startTime)) /
    //       1000
    //     ).toFixed(3);
    //     offlineData = {
    //       ...offlineData,
    //       [offlineDataLength]: {
    //         ...lastOfflineData,
    //         duration,
    //         startTime: new Date(lastOfflineData.startTime),
    //       },
    //     };
    //     offlineData = {};
    //     sessionStorage.setItem(
    //       'doselect_offline_status',
    //       JSON.stringify(offlineData)
    //     );
    //     updateOfllineDurationInfo(duration);
    //   }
    // }
  };
  const handleOffline = () => {
    const networkBroadbandiconDiv = document.getElementById(parentComponentId);
    if (networkBroadbandiconDiv) {
      networkBroadbandIconUI(networkBroadbandiconDiv, 'no-broadband');
    }

    // removing the offline logic from it as per project but will required
    // as plugin thats why not commented it instead of removing

    // let offlineData = sessionStorage.getItem('doselect_offline_status');
    // offlineData =
    //   offlineData && typeof offlineData === 'string'
    //     ? JSON.parse(offlineData)
    //     : {};
    // offlineData = {
    //   ...offlineData,
    //   [Object.keys(offlineData).length + 1]: {
    //     startTime: new Date(),
    //   },
    // };
    // sessionStorage.setItem(
    //   'doselect_offline_status',
    //   JSON.stringify(offlineData)
    // );
  };

  window.addEventListener('load', initiateSpeedDetection, false);
  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);
  window.addEventListener('unload', () => {
    clearInterval(networkSpeedInterval);
    clearInterval(offlineTrackerInterval);
    window.removeEventListener('online', handleOnline);
    window.removeEventListener('offline', handleOffline);
  });
};

export default initiateNetworkInfoData;
